// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@modern-js+webpack@1.21.6_typescript@4.7.4/node_modules/@modern-js/webpack/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@modern-js+webpack@1.21.6_typescript@4.7.4/node_modules/@modern-js/webpack/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feelgood-deliverer-sdk__description--MYhaQ{font-size:var(--fg-theme-question-size);line-height:var(--fg-theme-intro-lineHeight);margin:8px 0;overflow:hidden;white-space:pre-line;word-break:break-word}.feelgood-deliverer-sdk__description--MYhaQ .feelgood-deliverer-sdk__descriptionLink--JDut0{color:var(--fg-theme-entry);font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "feelgood-deliverer-sdk__description--MYhaQ",
	"descriptionLink": "feelgood-deliverer-sdk__descriptionLink--JDut0"
};
export default ___CSS_LOADER_EXPORT___;
